import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import parse from 'html-react-parser';


class ImportantPortal extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getImportantPortal();
    };



    getImportantPortal = async()=>{
        var id = await this.props.params.id;
        if(id){
            var response = await Api.GetRequest({}, 'important-portal/'+id);
            if(response.status == 200){
                this.setState({'important_portal' : response.important_portal});
            }
            else{
                toast.error("Something went wrong. Please try again later.");
            }
        }
        else{
            this.props.navigate(-1)
        }
       
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'important_portal' : {
                'description' : "",
                'mode_of_application' : "",
                'description_height' : "",
            }
        };
        this.description_ref = React.createRef();
        this.mode_of_application_ref = React.createRef();
    }

    
    setDescriptionHeight = async()=>{
        var height = this.description_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'description_height' : height + "px"});
    }


    setModeOfApplicationHeight = async()=>{
        var height = this.mode_of_application_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'mode_of_application_height' : height + "px"});
    }


    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src={process.env.REACT_APP_SERVER + this.state.important_portal.banner}/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>{this.state.important_portal.title}</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="news_details_main" class="section_padding">
                    <div class="container">
                        <div class="row" id="counter">
                            <div class="col-lg-8">
                                <div class="details_wrapper_area">
                                   
                                    <div class="details_text_wrapper text-start">
                                        <iframe  onLoad={()=>{this.setDescriptionHeight()}} scrolling="no" frameBorder="0" height={this.state.description_height} srcDoc={this.state.important_portal.description} ref={this.description_ref}  style={{'width':'100%'}}/>
                                        {this.state.important_portal.mode_of_application &&
                                            <>
                                                <h3 className="my-4">Mode Of Application</h3>
                                                <iframe  onLoad={()=>{this.setModeOfApplicationHeight()}} scrolling="no" frameBorder="0" height={this.state.mode_of_application_height} srcDoc={this.state.important_portal.mode_of_application} ref={this.mode_of_application_ref}  style={{'width':'100%'}}/>
                                            </>
                                        }
                                       
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="sidebar_first">
                                    <div class="share_causes_wrapper sidebar_boxed">
                                        <div class="sidebar_heading_main">
                                            <h3>Share</h3>
                                        </div>
                                        <div class="social_icon_sidebar">
                                            <ul>
                                                <li><a href="#!"><img src="/assets/img/icon/facebook.png" alt="icon"/></a></li>
                                                <li><a href="#!"><img src="/assets/img/icon/instagram.png" alt="icon"/></a></li>
                                                <li><a href="#!"><img src="/assets/img/icon/twitter.png" alt="icon"/></a></li>
                                                <li><a href="#!"><img src="/assets/img/icon/linkedin.png" alt="icon"/></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(ImportantPortal)